import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useData } from '../Form';
import { useStep } from '../Form';
import { useConferenceConfig } from '../components/ConferenceConfigContext';
import BackAndNextButtons from '../components/BackAndNextButtons';

export default function ServicesForm() {
  const { data, updateData } = useData();
  const { incrementStep } = useStep();
  const { config } = useConferenceConfig();
  const serviceOptions = config.serviceOptions || [];

  const [selected, setSelected] = useState(new Set(data.services ?? []));

  function toggle(option) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(option)) {
        next.delete(option);
      } else {
        next.add(option);
      }
      return next;
    });
  }

  function handleNext() {
    incrementStep(); // Proceed to the next step
    updateData({ services: [...selected] }); // Save the current form data
  }

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Services
      </Typography>
      <Typography>
        Please check any services you would be able to help with. Note: you may not end up being assigned to a service depending on how many people volunteer.
      </Typography>
      <FormGroup>
        {serviceOptions.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={selected.has(option)}
                onChange={() => toggle(option)}
              />
            }
            label={<Typography>{option}</Typography>}
          />
        ))}
      </FormGroup>

      <BackAndNextButtons handleNext={handleNext}></BackAndNextButtons>


    </React.Fragment>
  );
}
